import loadable from '@loadable/component';

export const OrgDashboardEditOrgPageLoadable = loadable(
  () => import('./OrgDashboardEditOrgPage'),
  {
    resolveComponent: (module) => module.OrgDashboardEditOrgPage,
  },
);
